// SUMMARY: Brand mark icon used inside the blue rounded-square logo tile. Swap the icon per project.

import { Hexagon } from 'lucide-react'
import type { ComponentProps } from 'react'

export function Logo(props: ComponentProps<typeof Hexagon>) {
	return <Hexagon {...props} />
}
